/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, toPathString, createRequestFunction } from '../common.js';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base.js';
/**
 * ClientSessionControllerV1Api - axios parameter creator
 */
export const ClientSessionControllerV1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get the customer data for a given client session. Returns empty values for Guest users
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionV1TenantCustomerGet: (tenant_1, ...args_1) => __awaiter(this, [tenant_1, ...args_1], void 0, function* (tenant, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('sessionV1TenantCustomerGet', 'tenant', tenant);
            const localVarPath = `/session/v1/{tenant}/customer`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the active eRX MFA Session for the user and it\'s state, if there is one
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} customerNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionV1TenantErxSessionStatusCustomerNumberGet: (tenant_1, customerNumber_1, ...args_1) => __awaiter(this, [tenant_1, customerNumber_1, ...args_1], void 0, function* (tenant, customerNumber, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('sessionV1TenantErxSessionStatusCustomerNumberGet', 'tenant', tenant);
            // verify required parameter 'customerNumber' is not null or undefined
            assertParamExists('sessionV1TenantErxSessionStatusCustomerNumberGet', 'customerNumber', customerNumber);
            const localVarPath = `/session/v1/{tenant}/erx-session-status/{customerNumber}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerNumber"}}`, encodeURIComponent(String(customerNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ClientSessionControllerV1Api - functional programming interface
 */
export const ClientSessionControllerV1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = ClientSessionControllerV1ApiAxiosParamCreator(configuration);
    return {
        /**
         * Get the customer data for a given client session. Returns empty values for Guest users
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionV1TenantCustomerGet(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sessionV1TenantCustomerGet(tenant, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ClientSessionControllerV1Api.sessionV1TenantCustomerGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns the active eRX MFA Session for the user and it\'s state, if there is one
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} customerNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionV1TenantErxSessionStatusCustomerNumberGet(tenant, customerNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sessionV1TenantErxSessionStatusCustomerNumberGet(tenant, customerNumber, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ClientSessionControllerV1Api.sessionV1TenantErxSessionStatusCustomerNumberGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * ClientSessionControllerV1Api - factory interface
 */
export const ClientSessionControllerV1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ClientSessionControllerV1ApiFp(configuration);
    return {
        /**
         * Get the customer data for a given client session. Returns empty values for Guest users
         * @param {ClientSessionControllerV1ApiSessionV1TenantCustomerGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionV1TenantCustomerGet(requestParameters, options) {
            return localVarFp.sessionV1TenantCustomerGet(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the active eRX MFA Session for the user and it\'s state, if there is one
         * @param {ClientSessionControllerV1ApiSessionV1TenantErxSessionStatusCustomerNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionV1TenantErxSessionStatusCustomerNumberGet(requestParameters, options) {
            return localVarFp.sessionV1TenantErxSessionStatusCustomerNumberGet(requestParameters.tenant, requestParameters.customerNumber, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ClientSessionControllerV1Api - object-oriented interface
 */
export class ClientSessionControllerV1Api extends BaseAPI {
    /**
     * Get the customer data for a given client session. Returns empty values for Guest users
     * @param {ClientSessionControllerV1ApiSessionV1TenantCustomerGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionV1TenantCustomerGet(requestParameters, options) {
        return ClientSessionControllerV1ApiFp(this.configuration).sessionV1TenantCustomerGet(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the active eRX MFA Session for the user and it\'s state, if there is one
     * @param {ClientSessionControllerV1ApiSessionV1TenantErxSessionStatusCustomerNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionV1TenantErxSessionStatusCustomerNumberGet(requestParameters, options) {
        return ClientSessionControllerV1ApiFp(this.configuration).sessionV1TenantErxSessionStatusCustomerNumberGet(requestParameters.tenant, requestParameters.customerNumber, options).then((request) => request(this.axios, this.basePath));
    }
}
